import { RefObject, useEffect } from 'react';

interface IUseOnBlurProps {
  ref: RefObject<HTMLElement | null> | HTMLElement | null;
  onBlur: (event: FocusEvent) => void;
}

const useOnBlur = ({ ref, onBlur }: IUseOnBlurProps): void => {
  useEffect(() => {
    let containerEl: HTMLElement | null = null;
    if (ref instanceof HTMLElement) {
      containerEl = ref;
    } else if (ref && ref.current) {
      containerEl = ref.current;
    }
    if (!containerEl) return;

    const handleBlur = (event: FocusEvent) => {
      onBlur(event);
    };

    containerEl.addEventListener('blur', handleBlur);

    return () => {
      containerEl.removeEventListener('blur', handleBlur);
    };
  }, [onBlur, ref]);
};

export default useOnBlur;
